__turbopack_context__.v({
  "bottomContainer": "style-module-scss-module__dVbB9G__bottomContainer",
  "breadcrumbs": "style-module-scss-module__dVbB9G__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__dVbB9G__breadcrumbsWrap",
  "content": "style-module-scss-module__dVbB9G__content",
  "parallaxImg": "style-module-scss-module__dVbB9G__parallaxImg",
  "parallaxWrapper": "style-module-scss-module__dVbB9G__parallaxWrapper",
  "pulse": "style-module-scss-module__dVbB9G__pulse",
  "screenContent": "style-module-scss-module__dVbB9G__screenContent",
  "screenInner": "style-module-scss-module__dVbB9G__screenInner",
  "screenWrapper": "style-module-scss-module__dVbB9G__screenWrapper",
  "shine": "style-module-scss-module__dVbB9G__shine",
  "sliderWrapper": "style-module-scss-module__dVbB9G__sliderWrapper",
  "title": "style-module-scss-module__dVbB9G__title",
  "wrapper": "style-module-scss-module__dVbB9G__wrapper",
});
